// ** Icons Import
import { Circle } from 'react-feather'

export default [
    {
        id: 'lesson',
        title: 'Cургалт',
        icon: <i className="fal fa-book"></i>,
        navLink: "/lesson",
        children: [

            {
                id: 'lesson-schedule',
                title: 'Хичээлийн хуваарь',
                icon: <Circle size={8} />,
                navLink: "lesson/lesson-schedule/"
            },
            {
                id: 'examination-schedule',
                title: 'Шалгалтын хуваарь',
                icon: <Circle size={8} />,
                navLink: "lesson/examination-schedule"
            },
            {
                id: 'study-plan',
                title: 'Сургалтын төлөвлөгөө',
                icon: <Circle size={8} />,
                navLink: "student/study-plan"
            },
            {
                id: 'offer-study-plan',
                title: 'Санал болгох сургалтын төлөвлөгөө',
                icon: <Circle size={8} />,
                navLink: "student/offer-study-plan"
            },
            {
                id: 'score-teacher',
                title: 'Явцын дүн',
                icon: <Circle size={8} />,
                navLink: "student/score-teacher/"
            },
            {
                id: 'score-information',
                title: 'Дүнгийн мэдээлэл',
                icon: <Circle size={8} />,
                navLink: "student/score-information/"
            },
            {
                id: "StudentAttendance",
                title: "Оюутны ирц",
                icon: <Circle size={8} />,
                navLink: "student/student-attendance"
            },
        ]
    },

]
